import { render, staticRenderFns } from "./ClientDtiInfoCard.vue?vue&type=template&id=a44d2de2&scoped=true&"
import script from "./ClientDtiInfoCard.vue?vue&type=script&lang=js&"
export * from "./ClientDtiInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientDtiInfoCard.vue?vue&type=style&index=0&id=a44d2de2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d2de2",
  null
  
)

export default component.exports